import React from 'react'
import clsx from 'clsx'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import CssBaseline from '@material-ui/core/CssBaseline'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import NoteAddRounded from '@material-ui/icons/NoteAddRounded'
import OfflinePinRounded from '@material-ui/icons/OfflinePinRounded'
import FindInPageRoundedIcon from '@material-ui/icons/FindInPageRounded'
import SpellcheckRounded from '@material-ui/icons/SpellcheckRounded'
import BallotSharpIcon from '@material-ui/icons/BallotSharp'
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark'
import DirectionsRunRoundedIcon from '@material-ui/icons/DirectionsRunRounded'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepButton from '@material-ui/core/StepButton'
import StepLabel from '@material-ui/core/StepLabel'
import {
  setDocs, 
  stepsCompleted, 
  setStepsCompleted,
  setOpenPlan,
  usePlan,
  setPlan,
  setSelectedSOPs,
  useSelectedSOPs,
  useDocs
} from '../redux/plan'
import {useName, useRoles, useToken } from '../redux/auth'
import { useSelectedModule, setSelectedModule, setOpenDialog, useChanges, setChanges } from '../redux/navigation'
import RenderRoute from '../components/rendersopsubmodules'
import Dialog from '../components/closedialog'
import { getFinal } from '../modules/db'
import { theme as gloTheme } from "../theme";

const drawerWidth = 240
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  completed : {
    backgroundColor: gloTheme.colors.secondary
  }
}))

const SOP = () => {
  const {colors} = gloTheme
  const token = useToken()
  const changes = useChanges()
  const docs = useDocs()
  const theplan = usePlan()
  if(!theplan._id){
    const localPlan = JSON.parse(localStorage.getItem("plan"))
    if(localPlan && localPlan.plan){
      console.log("local._id "+localPlan.plan._id)
      theplan._id = localPlan.plan._id
      theplan._rev = localPlan.plan._rev
    }
    

}
  const completed = stepsCompleted()
  const setCompleted = setStepsCompleted
  const selected = useSelectedSOPs()
  const icns = {
    create:<NoteAddRounded />, 
    approve:<OfflinePinRounded />, 
    find:<FindInPageRoundedIcon />, 
    edit:<SpellcheckRounded />, 
    organize:<BallotSharpIcon />,
    plan:<CollectionsBookmarkIcon />,
    logout:<DirectionsRunRoundedIcon />
  }
  const steps = ['Find', 'Organize', 'Preview']
  const roles = useRoles()
  const name = useName()
  const [open, setOpen] = React.useState(false);
  const [changeResponse, setChangeResponse] = React.useState(false);

  
  const classes = useStyles()
  const theme = useTheme()
  
  const handleDrawerOpen = () => {
    setOpen(true)
  }
  const handleDialogNeg = () => {
    setOpenDialog({
      open:false, 
      txt:'',
      neg:null,
      pos:null
    })
  }
  const handleDialogPos = () => {
    setOpenDialog({
      open:false, 
      txt:'',
      neg:null,
      pos:null
    })
    setPlan({name:'', _id:'', _rev:'', process:''})
    setSelectedSOPs([])
    setOpenPlan(false)
    setDocs(false)
    setStepsCompleted([false, false, false])
  }

  const handleClose = () => {
    setOpenDialog(
      {
        open:true, 
        txt:'You are about to close this, if your changes are not saved yet, they will be lost.',
        neg : handleDialogNeg,
        pos : handleDialogPos
      }
    )
  }
  
  
  const selectedModule = useSelectedModule()

  const handleDrawerClose = () => {
    setOpen(false)
  }
  const removeChanges = () => {
    setChangeResponse(true)
    setChanges(false)
    setOpenDialog(
      {
        open:false, 
        txt:'',
        neg : null,
        pos : null
      }
    )
  }
  const acceptlost = (sel) => {
    setChangeResponse(false)
    setChanges(false)
    setSelectedModule(sel)
    const ind = steps.indexOf(sel)
    check(ind)
    setOpenDialog(
      {
        open:false, 
        txt:'',
        neg : null,
        pos : null
      }
    )
  }
  const handleMenuClick = (sel) => {
    if(!changes){
      setSelectedModule(sel)
      const ind = steps.indexOf(sel)
      check(ind)
    } else {
      setOpenDialog(
        {
          open:true, 
          txt:'Remember to save your changes, continue anyway?',
          neg : removeChanges,
          pos : ()=>acceptlost(sel)
        }
      )
    }
  }
  const check = (it) => {
    let res = [true, false, false]
    for (let index = 1; index < 3; index++) {
      if(index < it+1){
        res[index] = true
      } else {
        res[index] = false
      }
    }
    setCompleted(res)
  }
  const handleStep = async (mod) => {
    if(mod !== 'Preview'){
      const ind = steps.indexOf(mod)
      check(ind)
    }
    else if(mod === 'Preview'){
      const ids = selected ? selected.map(x => x._id) : []
      await getFinal(ids, token)
      const ind = steps.indexOf(mod)
      check(ind)
    }

    setSelectedModule(mod)
  }
  return (
    <div className={classes.root}>
      <Dialog/>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
        style={{ backgroundColor: colors.primary }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          { docs ?
              <Typography variant="h6" noWrap>
                AutoHACCP
              </Typography>
            :
              <Typography variant="h6" noWrap>
                AutoHACCP - {theplan.name}
              </Typography>
          }
          { docs ? <div></div>
          :
            <Stepper
            style={{ 
              flex:1, 
              backgroundColor: colors.primary, 
              line: {
                height: 3,
                border: 0,
                borderRadius: 1,
              }
            }}
             activeStep={selectedModule}>
            {steps.includes(selectedModule) ? steps.map((label, index) => (
              <Step 
                key={label} 
                style={{ 
                  backgroundColor: colors.primary, 
                  }}
                >
                <StepButton 
                  onClick={()=>handleStep(label)} 
                  completed={completed[index]} 
                  style={{ 
                    backgroundColor: colors.primary, 
                    color: colors.light,
                    }}
                  >
                  <StepLabel
                    label={classes.completed}
                  >
                    {label}
                  </StepLabel>
                </StepButton>
              </Step>
            )) : null}
          </Stepper>
          }
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <Typography variant="h6" noWrap>
            {name.charAt(0).toUpperCase() + name.slice(1)}
          </Typography>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? 
            <ChevronRightIcon /> : 
            <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
        {
          roles.includes('admin') ?
          <List>
            {(docs ? ['Approve', 'Create' ] : ['Find', 'Organize']).map((text, index) => (
              <ListItem button key={text}
                onClick={()=>handleMenuClick(text)}
              >
                <ListItemIcon style={
                  selectedModule === text ? {color:colors.secondary}:{}
                }>{icns[text.toLowerCase()]}</ListItemIcon>
                <ListItemText style={
                  selectedModule === text ? {color:colors.secondary}:{}
                }
                primary={text} />
              </ListItem>
            ))}
          </List> :
          <List>
            {(docs ? ['Create'] : ['Find', 'Organize']).map((text, index) => (
              <ListItem button key={text}
                onClick={()=>handleMenuClick(text)}
              >
                <ListItemIcon>{icns[text.toLowerCase()]}</ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
        }
        <Divider />
        <List>
          {['Close Plan'].map((text, index) => (
            <ListItem button key={text} onClick={handleClose}>
              <ListItemIcon>{icns['logout']}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <RenderRoute />
      </main>
    </div>

  )
}

export default SOP
